// extracted by mini-css-extract-plugin
module.exports = {"addWrp":"addProductToProject_addWrp__2ERtt"};